import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { AuthProvider } from "@/contexts/AuthContext";
import { Toaster } from "@/components/ui/sonner";
import ProtectedRoute from "@/components/ProtectedRoute";
import AuthCallback from "@/components/AuthCallback";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import SopWizard from "@/pages/SopWizard";
import SopView from "@/pages/SopView";
import UserManagement from "@/pages/UserManagement";
import Help from "@/pages/Help";

function AppRouter() {
  const location = useLocation();
  // Detect session_id during render (not in useEffect) to avoid race conditions
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/" element={<Login />} />
      <Route path="/login" element={<Login />} />
      <Route
        path="/dashboard"
        element={
          <ProtectedRoute>
            <Dashboard />
          </ProtectedRoute>
        }
      />
      <Route
        path="/sops/new"
        element={
          <ProtectedRoute>
            <SopWizard />
          </ProtectedRoute>
        }
      />
      <Route
        path="/sops/:id/edit"
        element={
          <ProtectedRoute>
            <SopWizard />
          </ProtectedRoute>
        }
      />
      <Route
        path="/sops/:id"
        element={
          <ProtectedRoute>
            <SopView />
          </ProtectedRoute>
        }
      />
      <Route
        path="/users"
        element={
          <ProtectedRoute>
            <UserManagement />
          </ProtectedRoute>
        }
      />
      <Route
        path="/aide"
        element={
          <ProtectedRoute>
            <Help />
          </ProtectedRoute>
        }
      />
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <AppRouter />
          <Toaster position="top-right" richColors />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
